import PropTypes from 'prop-types'

import { Container } from './styles'

const WysiwygContent = ({
  content, className
}) => {
  if (!content) return null

  return (
    <Container className={className} dangerouslySetInnerHTML={{ __html: content.replace(/(\r\n|\n|\r|\t)/gm, '') }} />
  )
}

WysiwygContent.propTypes = {
  content: PropTypes.string.isRequired,
  className: PropTypes.string
}
WysiwygContent.defaultProps = {
  className: ''
}

export default WysiwygContent
